// Remote Logger - отправляет console.log на сервер для удалённой отладки
import { API_BASE_URL } from '../config';

const REMOTE_LOG_ENABLED = import.meta.env.VITE_DEV_MODE === 'true';
const LOG_ENDPOINT = `${API_BASE_URL}/client-logs`;
const LOG_BUFFER = [];
const FLUSH_INTERVAL = 2000; // 2 секунды
const MAX_BUFFER_SIZE = 50;

// Генерируем уникальный session ID
const SESSION_ID = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

// Получаем Telegram user id если доступен
const getTelegramUserId = () => {
    try {
        return window.Telegram?.WebApp?.initDataUnsafe?.user?.id || 'unknown';
    } catch {
        return 'unknown';
    }
};

// Отправка логов на сервер
const flushLogs = async () => {
    if (LOG_BUFFER.length === 0) return;

    const logsToSend = [...LOG_BUFFER];
    LOG_BUFFER.length = 0;

    try {
        await fetch(LOG_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                session_id: SESSION_ID,
                telegram_user_id: getTelegramUserId(),
                logs: logsToSend,
                user_agent: navigator.userAgent,
                url: window.location.href
            })
        });
    } catch (error) {
        // Не логируем ошибку чтобы избежать рекурсии
    }
};

// Добавляем лог в буфер
const addLog = (level, args) => {
    if (!REMOTE_LOG_ENABLED) return;

    const log = {
        timestamp: new Date().toISOString(),
        level,
        message: args.map(arg => {
            try {
                if (typeof arg === 'object') {
                    return JSON.stringify(arg, null, 2);
                }
                return String(arg);
            } catch {
                return '[Unserializable]';
            }
        }).join(' ')
    };

    LOG_BUFFER.push(log);

    // Если буфер переполнен, отправляем сразу
    if (LOG_BUFFER.length >= MAX_BUFFER_SIZE) {
        flushLogs();
    }
};

// Перехватыва��м console методы
const originalConsole = {
    log: console.log.bind(console),
    warn: console.warn.bind(console),
    error: console.error.bind(console),
    info: console.info.bind(console)
};

export const initRemoteLogger = () => {
    if (!REMOTE_LOG_ENABLED) {
        console.log('🔇 Remote logger disabled (VITE_DEV_MODE !== true)');
        return;
    }

    console.log = (...args) => {
        originalConsole.log(...args);
        addLog('log', args);
    };

    console.warn = (...args) => {
        originalConsole.warn(...args);
        addLog('warn', args);
    };

    console.error = (...args) => {
        originalConsole.error(...args);
        addLog('error', args);
    };

    console.info = (...args) => {
        originalConsole.info(...args);
        addLog('info', args);
    };

    // Перехватываем необработанные ошибки
    window.addEventListener('error', (event) => {
        addLog('error', [`Uncaught Error: ${event.message}`, `at ${event.filename}:${event.lineno}:${event.colno}`]);
    });

    window.addEventListener('unhandledrejection', (event) => {
        addLog('error', [`Unhandled Promise Rejection: ${event.reason}`]);
    });

    // Периодически отправляем логи
    setInterval(flushLogs, FLUSH_INTERVAL);

    // Отправляем при закрытии страницы
    window.addEventListener('beforeunload', flushLogs);

    originalConsole.log('📡 Remote logger initialized, session:', SESSION_ID);
};

export default { initRemoteLogger };
